var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"general-spinner"},[_c('div',{staticClass:"loadingio-spinner-rolling-rbsd7qu9x07"},[_c('div',{staticClass:"ldio-rvqf9xyvmmb"},[_c('div')])])])
}]

export { render, staticRenderFns }